import { Box } from '@mui/material';
import { BORDER_RADIUS } from '../../../constants/styles';

export const CardMedia = ({ image, alt = '' }) => {
  return (
    <Box
      component="img"
      src={image}
      alt={alt}
      sx={{
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        display: 'block',
        verticalAlign: 'middle',
        borderRadius: BORDER_RADIUS,
        pointerEvents: 'none'
      }}
    />
  );
}; 